import { render, staticRenderFns } from "./BookingDetailsView.vue?vue&type=template&id=7136a741&scoped=true"
import script from "./BookingDetailsView.vue?vue&type=script&lang=js"
export * from "./BookingDetailsView.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailsView.vue?vue&type=style&index=0&id=7136a741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136a741",
  null
  
)

export default component.exports